import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section id="inicio" className="relative min-h-screen flex items-center overflow-hidden" data-id="element-105">
      <div className="absolute inset-0" data-id="element-106">
        <img src="https://cdn.magicpatterns.com/uploads/kpoXn7PSmRXpLTLEpQaajP/IMG_6885.jpg" alt="Jade en vivo" className="w-full h-full object-cover" data-id="element-107" />
        <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/80 to-ink/40" data-id="element-108" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-transparent to-ink/60" data-id="element-109" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-32 w-full" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-3xl" data-id="element-111">
          <p className="text-gold text-xs md:text-sm tracking-[0.35em] mb-6 font-medium" data-id="element-112">
            {t('hero.eyebrow')}
          </p>
          <h1 className="font-display text-4xl md:text-6xl lg:text-7xl leading-[1.05] text-cream mb-6" data-id="element-113">
            {t('hero.title.1')}{' '}
            <span className="italic gold-text" data-id="element-114">{t('hero.title.2')}</span>
          </h1>
          <p className="text-cream/70 text-lg md:text-xl max-w-2xl mb-10 leading-relaxed" data-id="element-115">
            {t('hero.subtitle')}
          </p>
          <div className="flex flex-wrap gap-4" data-id="element-116">
            <a href="#contacto" className="group inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-gold text-ink font-medium hover:bg-gold-light transition-colors" data-id="element-117">
              {t('hero.cta.primary')}
              <ArrowRightIcon size={18} className="group-hover:translate-x-1 transition-transform" data-id="element-118" />
            </a>
            <a href="#servicios" className="inline-flex items-center px-7 py-3.5 rounded-full border border-gold/40 text-cream hover:border-gold hover:bg-gold/5 transition-colors" data-id="element-119">
              {t('hero.cta.secondary')}
            </a>
          </div>
        </motion.div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-gold/60 text-xs tracking-[0.3em]" data-id="element-120">
        {t('hero.scroll')}
      </div>
    </section>;
}